import { render } from "./ManageListView.vue?vue&type=template&id=324db17f"
import script from "./ManageListView.vue?vue&type=script&lang=js"
export * from "./ManageListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__